import React from "react";
import { AuthContext } from "../../context/Auth/auth";
import Sidebar from "./Sidebar";
import { Container } from "./style";

const SellComponent = () => {
  const auth = AuthContext();

  return (
    <>
      {auth?.logIn ? (
        <Container>
          <Sidebar />
        </Container>
      ) : (
        <div>Login First</div>
      )}
    </>
  );
};

export default SellComponent;
